export class S3SourceProperties {
    'bucket';
    'prefix';
    'region';
    'ownerAccountId';
    'fileFormat';
    'partitionType';
    'bucketPathPartitionSpec';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "ownerAccountId",
            "baseName": "ownerAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "fileFormat",
            "baseName": "fileFormat",
            "type": "FileFormat",
            "format": ""
        },
        {
            "name": "partitionType",
            "baseName": "partitionType",
            "type": "PartitionType",
            "format": ""
        },
        {
            "name": "bucketPathPartitionSpec",
            "baseName": "bucketPathPartitionSpec",
            "type": "BucketPathPartitionSpec",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return S3SourceProperties.attributeTypeMap;
    }
    constructor() {
    }
}
